import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { Injectable } from '@angular/core';
import { WorkflowTaskModel } from '../../common/workflowTask.model';
import { WorkflowTaskSummaryConverter } from '../../common/converter/workflowTaskSummary.converter';
import {
    DiscussionSummaryConverter
} from '../../../../../../discussion/modules/common/api/converter/discussionSummary.converter';
import { WorkflowTaskAttributeSummaryModel } from '../workflowTaskAttributeSummary.model';

@Injectable({
    providedIn: 'root'
})
export class WorkflowTaskAttributeSummaryConverter extends HttpModelConverter<WorkflowTaskAttributeSummaryModel> {

    constructor() {
        super();
    }

    protected createInstance(): WorkflowTaskAttributeSummaryModel {
        return new WorkflowTaskAttributeSummaryModel();
    }

    protected enrichObject(result: WorkflowTaskAttributeSummaryModel, src: WorkflowTaskAttributeSummaryModel) {
    }


}
